import {
  HandlersLocationTypeResponse,
  useDeleteApiLocationTypesByLocationTypeMutation,
  useGetApiLocationTypesQuery,
  usePatchApiLocationTypesByLocationTypeMutation,
  usePostApiLocationTypesMutation,
} from '../../../../app/athenaApiGen';
import AdminCatalogPanel from '../AdminCatalogPanel';

const AdminLocationTypesPanel = () => (
  <AdminCatalogPanel<HandlersLocationTypeResponse>
    tableName="Location Type"
    apiPath="/api/location-types"
    pkAccessor="locationType"
    useList={() => useGetApiLocationTypesQuery({})}
    useCreate={usePostApiLocationTypesMutation}
    useUpdate={usePatchApiLocationTypesByLocationTypeMutation}
    useDelete={useDeleteApiLocationTypesByLocationTypeMutation}
    buildCreateArg={(v) => ({
      handlersLocationTypeRequest: {
        locationType: (v.locationType as string) ?? '',
        description: v.description as string | undefined,
      },
    })}
    buildUpdateArg={(row, v) => ({
      locationType: row.locationType as string,
      handlersLocationTypeUpdateRequest: {
        description: v.description as string | undefined,
      },
    })}
    buildDeleteArg={(row) => ({ locationType: row.locationType as string })}
    fields={[
      {
        name: 'locationType',
        label: 'Location Type',
        type: 'text',
        required: true,
        immutableOnEdit: true,
        helperText: 'Max 50 characters; immutable after creation.',
      },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'archived', label: 'Archived', type: 'boolean' },
    ]}
    fkConflictMessage="One or more (non-archived) Locations still reference this type. Reassign them before deleting."
  />
);

export default AdminLocationTypesPanel;
